import React from "react";
import { Paths } from "./../../constants/UrlConstants";
import { Link } from "react-router-dom";
import layoutStyle from "../../assets/css/modules/shared/layout.css";

const checkListContentForNewClaim = [
  "GP open referral letter",
  "Your condition and treatment details",
  "Specialist or healthcare provider details (if you have them)"
];

let checkListContentForExistingClaim = [...checkListContentForNewClaim];
checkListContentForExistingClaim[1] = "Your treatment details";

const DoesNotRequireAuthorisation = {
  doesNotRequireAuthorisationLabel:
    "Please have the following ready for your claim submission:",
  doesNotRequireAuthorisationCheckListForNewClaim: checkListContentForNewClaim,
  doesNotRequireAuthorisationCheckListForExistingClaim: checkListContentForExistingClaim,
  doesNotRequireAuthorisationSLA: (
    <React.Fragment>
      If your treatment is urgent,
      please{" "}
      <Link
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        to={Paths.ContactUs}
      >
        call us
      </Link>{" "}
      for authorisation.
    </React.Fragment>
  ),
  phinNotice: (
    <React.Fragment>
      You can find independent information about the quality and cost of private
      treatment available from doctors and hospitals by looking at the Private
      Healthcare Information Network website at{" "}
      <a
        className={"hol-link " + layoutStyle.anchorDecorationUnderline}
        href="https://www.phin.org.uk"
        target="_blank"
        rel="noopener noreferrer"
      >
        www.phin.org.uk
      </a>
      .<br />
      <br />
    </React.Fragment>
  ),
  infoBoxIconClass: "icon-help-outline"
};

export default DoesNotRequireAuthorisation;
